// src/pages/Landing/Landing.js - COMPLETE WITH HELP SECTION
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MultiStepSignup from '../../components/Auth/MultiStepSignup';
import AuthModal from '../../components/common/UI/AuthModal';
import landingMobile from '../../assets/images/landing-mobile.jpg';
import landingDesktop from '../../assets/images/landing-desktop.jpg';
// TODO: Add these placeholder images (tiny 20-50px versions)
// import landingMobilePlaceholder from '../../assets/images/landing-mobile-placeholder.jpg';
// import landingDesktopPlaceholder from '../../assets/images/landing-desktop-placeholder.jpg';
import './Landing.css';

const Landing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSignup, setShowSignup] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [referralCode, setReferralCode] = useState('');
  
  // Image loading states
  const [mobileImageLoaded, setMobileImageLoaded] = useState(false);
  const [desktopImageLoaded, setDesktopImageLoaded] = useState(false);

  // Preload images for smooth transition
  useEffect(() => {
    const preloadImage = (src, callback) => {
      const img = new Image();
      img.src = src;
      img.onload = () => callback(true);
      img.onerror = () => {
        console.error('Failed to load image:', src);
        callback(true); // Still show content even if image fails
      };
    };

    preloadImage(landingMobile, setMobileImageLoaded);
    preloadImage(landingDesktop, setDesktopImageLoaded);
  }, []);

  // Extract referral code and mode from URL
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const refCode = queryParams.get('ref');
    const mode = queryParams.get('mode');
    
    if (refCode) {
      console.log('🔗 Referral code detected:', refCode);
      setReferralCode(refCode);
      localStorage.setItem('pending_referral_code', refCode);
    }
    
    // Auto-open modals based on URL mode
    if (mode === 'signup' || location.pathname === '/signup') {
      setShowSignup(true);
    } else if (mode === 'login') {
      setAuthMode('login');
      setShowAuthModal(true);
    }
  }, [location.search, location.pathname]);

  const handleSignupClick = () => {
    console.log('🖱️ Signup button clicked');
    setShowSignup(true);
    setShowAuthModal(false);
  };

  const handleLoginClick = () => {
    console.log('🖱️ Login button clicked');
    setAuthMode('login');
    setShowAuthModal(true);
    setShowSignup(false);
  };

  const handleSignupClose = () => {
    setShowSignup(false);
    localStorage.removeItem('pending_referral_code');
  };

  const handleAuthModalClose = () => {
    setShowAuthModal(false);
  };

  const handleSignupSuccess = () => {
    setShowSignup(false);
  };

  return (
    <div className="landing-container">
      {/* Mobile Background with Progressive Loading */}
      <div className="landing-background mobile">
        {/* Solid color fallback (shows instantly) */}
        <div className="landing-bg-fallback" />
        
        {/* Full Image */}
        <div 
          className={`landing-bg-full ${mobileImageLoaded ? 'loaded' : ''}`}
          style={{ backgroundImage: `url(${landingMobile})` }}
        />
        
        {/* ✅ Help Section - Mobile (Top) */}
        <div className="landing-help-section mobile">
          <p>
            Need help?{' '}
            <a 
              href="mailto:support@trexarng.com"
              onClick={(e) => e.stopPropagation()}
            >
              Contact us
            </a>
          </p>
        </div>
        
        {/* Real Buttons for Mobile */}
        <div className="landing-buttons mobile">
          <button className="landing-btn signup-btn" onClick={handleSignupClick}>
            Sign Up
          </button>
          <button className="landing-btn login-btn" onClick={handleLoginClick}>
            Sign In
          </button>
        </div>
      </div>

      {/* Desktop Background with Progressive Loading */}
      <div className="landing-background desktop">
        {/* Solid color fallback (shows instantly) */}
        <div className="landing-bg-fallback" />
        
        {/* Full Image */}
        <div 
          className={`landing-bg-full ${desktopImageLoaded ? 'loaded' : ''}`}
          style={{ backgroundImage: `url(${landingDesktop})` }}
        />
        
        {/* Real Buttons for Desktop */}
        <div className="landing-buttons desktop">
          <button className="landing-btn signup-btn" onClick={handleSignupClick}>
            Get Started
          </button>
          <button className="landing-btn login-btn" onClick={handleLoginClick}>
            Sign In
          </button>
        </div>
        
        {/* ✅ Help Section - Desktop (Beside buttons) */}
        <div className="landing-help-section desktop">
          <p>
            Need help?{' '}
            <a 
              href="mailto:support@trexarng.com"
              onClick={(e) => e.stopPropagation()}
            >
              Contact us
            </a>
          </p>
        </div>
      </div>

      {/* Multi-Step Signup Modal (NEW) */}
      {showSignup && (
        <MultiStepSignup
          onClose={handleSignupClose}
          onSuccess={handleSignupSuccess}
        />
      )}

      {/* Old Auth Modal for Login (KEPT AS IT WAS) */}
      {showAuthModal && (
        <AuthModal
          isOpen={showAuthModal}
          onClose={handleAuthModalClose}
          mode={authMode}
          onSwitchMode={(mode) => {
            if (mode === 'register') {
              setShowAuthModal(false);
              setShowSignup(true);
            } else {
              setAuthMode(mode);
            }
          }}
          referralCode={referralCode}
        />
      )}
    </div>
  );
};

export default Landing;